"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSelectorFunctions = exports.transform = exports.persistCampaignIds = exports.fireEvent = exports.fireEachEvent = exports.expandRules = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _omitBy2 = _interopRequireDefault(require("lodash/omitBy"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _cookieUtils = _interopRequireDefault(require("../utils/cookieUtils"));

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var createTargetExperimentProp = function createTargetExperimentProp(state) {
  var variations = (0, _get2.default)(state, 'experimentV2.variations', {});
  var experimentString = Object.keys(variations).reduce(function (acc, variationKey) {
    var variation = variations[variationKey];
    var variationName = (0, _get2.default)(variation, 'variation.name');

    if (variationName) {
      if (acc === '') {
        return "".concat(variationKey, ":").concat(variationName);
      } else {
        return "".concat(acc, ",").concat(variationKey, ":").concat(variationName);
      }
    } else {
      return acc;
    }
  }, '');
  return experimentString === '' ? {} : {
    atTestOffer: experimentString
  };
};

var escapeSpecialChars = function escapeSpecialChars(value) {
  var escapeMapping = {
    '"': '\\"',
    '\\': '\\\\',
    '/': '\\/',
    '\b': '\\b',
    '\f': '\\f',
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t'
  };
  var escapeReg = /["/\\\b\f\n\r\t]/g;
  return typeof value === 'string' ? value.replace(escapeReg, function (char) {
    return escapeMapping[char];
  }) : value;
};

var transform = function transform(properties, element, state) {
  var stateReg = /\[\[(.*?)]]/g;
  var elementReg = /<<(.*?)>>/g;

  var replaceValues = function replaceValues(val) {
    return val.replace(elementReg, function (match) {
      return (0, _get2.default)(element, match.slice(2).slice(0, match.length - 4));
    }).replace(stateReg, function (match) {
      return (0, _get2.default)(state, match.slice(2).slice(0, match.length - 4));
    });
  };

  var nonFunctionProperties = (0, _omitBy2.default)(properties, _isFunction2.default);
  return typeof properties === 'string' ? replaceValues(properties) : (0, _pickBy2.default)(JSON.parse(JSON.stringify(nonFunctionProperties).replace(elementReg, function (match) {
    return escapeSpecialChars((0, _get2.default)(element, match.slice(2).slice(0, match.length - 4)));
  }).replace(stateReg, function (match) {
    return escapeSpecialChars((0, _get2.default)(state, match.slice(2).slice(0, match.length - 4)));
  }), function (k, v) {
    return v === 'undefined' || v === 'null' ? null : v;
  }));
};

exports.transform = transform;

var transformSelectorFunctions = function transformSelectorFunctions(properties, element, state) {
  var functionProperties = (0, _pickBy2.default)(properties, _isFunction2.default);
  var transformed = (0, _mapValues2.default)(functionProperties, function (selectorFunction) {
    var selectorVal = selectorFunction(state, element);
    return selectorVal === undefined ? selectorVal : String(selectorVal);
  });
  return transformed;
};

exports.transformSelectorFunctions = transformSelectorFunctions;

var expandRules = function expandRules(rules) {
  if (typeof (rules || {}).elements === 'undefined') {
    return rules;
  }

  var elementRules = _objectSpread(_objectSpread({}, rules), {}, {
    elements: {}
  });

  var re = /\[(.*?)]/;
  (0, _mapValues2.default)(rules.elements, function (events, id) {
    var idPartials = id.match(re);

    if (idPartials && idPartials[1]) {
      var idHead = id.split('[').shift();
      var idTail = id.split(']').pop();
      idPartials[1].split(',').map(function (idMatch) {
        elementRules.elements["".concat(idHead || '').concat(idMatch.trim()).concat(idTail || '')] = events;
      });
    } else {
      elementRules.elements[id] = events;
    }
  });
  return elementRules;
};

exports.expandRules = expandRules;

var persistCampaignIds = function persistCampaignIds(state, queryParams) {
  // Check for campaign query params and persist to a cookie if present
  var campaignKeys = (0, _get2.default)(state, 'config.campaignKeys');
  (0, _forEach2.default)(campaignKeys, function (segmentPropertyName, queryParamName) {
    var keyParam = (0, _get2.default)(queryParams, queryParamName);

    if (keyParam) {
      var expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + _constants.sessionDurationMs);

      _cookieUtils.default.setCookie(segmentPropertyName, keyParam, expireDate.toGMTString());
    }
  });
};

exports.persistCampaignIds = persistCampaignIds;

var fireEvent = function fireEvent(e, values) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var state = arguments.length > 3 ? arguments[3] : undefined;
  var analyticEvent = arguments.length > 4 ? arguments[4] : undefined;
  var defaultProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  // If there is a defined "condition", return if it is 'false'
  if (!values || typeof values.condition === 'function' && !values.condition(e.currentTarget, state)) {
    return;
  }

  var selectedEvent = (0, _get2.default)(values, 'analyticEvent', analyticEvent);
  var haTaskTaxonomyTestTaxonomyName = typeof window !== 'undefined' ? _cookieUtils.default.getCookie('haTaskTaxonomyTestTaxonomyName') : undefined;

  if (values.name) {
    var name = transformSelectorFunctions({
      name: values.name
    }, e.currentTarget, state).name || values.name;

    switch (e.type) {
      case 'mouseover' || 'mouseout':
        if (!e.currentTarget.contains(e.relatedTarget)) {
          selectedEvent(name, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, createTargetExperimentProp(state)), defaultProps), transform(values.properties, e.currentTarget, state)), transformSelectorFunctions(values.properties, e.currentTarget, state)), {}, {
            haTaskTaxonomyTestTaxonomyName: haTaskTaxonomyTestTaxonomyName
          }), callback);
        }

        break;

      default:
        selectedEvent(name, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, createTargetExperimentProp(state)), defaultProps), transform(values.properties, e.currentTarget, state)), transformSelectorFunctions(values.properties, e.currentTarget, state)), {}, {
          haTaskTaxonomyTestTaxonomyName: haTaskTaxonomyTestTaxonomyName
        }), callback);
    }
  }
};

exports.fireEvent = fireEvent;

var fireEachEvent = function fireEachEvent(e, analyticsValues) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var appState = arguments.length > 3 ? arguments[3] : undefined;
  var analyticEvent = arguments.length > 4 ? arguments[4] : undefined;
  var defaultProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  if (Array.isArray(analyticsValues)) {
    analyticsValues.forEach(function (item) {
      fireEvent(e, item, callback, appState, analyticEvent, defaultProps);
    });
  } else {
    fireEvent(e, analyticsValues, callback, appState, analyticEvent, defaultProps);
  }
};

exports.fireEachEvent = fireEachEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/analyticsUtils.js
// module id = 666
// module chunks = 25